import { client } from './client'
import type { TestSuiteDetails, CreateTestSuitesRequest, CreateTestSuitesResponse, PushTestSuiteRequest, PushTestItemsResponse } from '@/types'

export const testSuitesApi = {
  getDetails: (projectId: string, testSuiteId: string) =>
    client.get<TestSuiteDetails>(
      `/projects/${projectId}/test-suites/${testSuiteId}`,
    ).then(r => r.data),

  create: (projectId: string, testPlanId: string, data: CreateTestSuitesRequest) =>
    client.post<CreateTestSuitesResponse>(
      `/projects/${projectId}/test-plans/${testPlanId}/test-suites`,
      data,
    ).then(r => r.data),

  delete: (projectId: string, testSuiteId: string) =>
    client.delete(`/projects/${projectId}/test-suites/${testSuiteId}`),

  pushToDevOps: (projectId: string, testSuiteId: string, data: PushTestSuiteRequest) =>
    client.post<PushTestItemsResponse>(
      `/projects/${projectId}/test-suites/${testSuiteId}/push-to-devops`,
      data,
    ).then(r => r.data),
}
